(() => {
  const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

  const rafThrottle = (fn) => {
    let ticking = false;
    return () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        fn();
      });
    };
  };

  const initSwipeIndicators = (root = document) => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("[data-es-swipe]").forEach((swipe) => {
      if (swipe.__esIndicatorInit) return;

      const indicator =
        swipe.parentElement && swipe.parentElement.querySelector(".es-swipe-indicator");
      if (!indicator) return;

      swipe.__esIndicatorInit = true;

      const update = () => {
        const max = swipe.scrollWidth - swipe.clientWidth;
        const progress = max > 0 ? swipe.scrollLeft / max : 0;
        indicator.style.setProperty("--es-progress", String(progress));
      };

      const onScroll = rafThrottle(update);

      swipe.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });

      // Initial state
      update();
    });
  };

  const observeForNewSwipes = () => {
    if (!window.MutationObserver) return;

    let timer = null;
    const schedule = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => initSwipeIndicators(), 50);
    };

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes || []) {
          if (n && n.nodeType === 1) {
            const el = n;
            if (
              (el.matches && el.matches("[data-es-swipe]")) ||
              (el.querySelector && el.querySelector("[data-es-swipe]"))
            ) {
              schedule();
              return;
            }
          }
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
  };

  // Init indicators ASAP
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initSwipeIndicators();
      observeForNewSwipes();
    });
  } else {
    initSwipeIndicators();
    observeForNewSwipes();
  }


  document.addEventListener(
    "touchstart",
    (e) => {
      if (!isMobile()) return;
      const swipe = e.target.closest && e.target.closest("[data-es-swipe]");
      if (!swipe) return;

      const t = e.touches && e.touches[0];
      if (!t) return;

      swipe.__esStartX = t.clientX;
      swipe.__esStartY = t.clientY;
      swipe.__esMoved = false;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      if (!isMobile()) return;
      const swipe = e.target.closest && e.target.closest("[data-es-swipe]");
      if (!swipe) return;

      const t = e.touches && e.touches[0];
      if (!t) return;

      const dx = Math.abs(t.clientX - (swipe.__esStartX || 0));
      const dy = Math.abs(t.clientY - (swipe.__esStartY || 0));

      // Horizontal swipe: mark moved (prevents accidental click)
      if (dx > 10 && dy < 25) swipe.__esMoved = true;
    },
    { passive: true }
  );

  // Capture click and prevent navigation if it was a swipe gesture
  document.addEventListener(
    "click",
    (e) => {
      if (!isMobile()) return;
      const swipe = e.target.closest && e.target.closest("[data-es-swipe]");
      if (!swipe) return;

      if (swipe.__esMoved) {
        e.preventDefault();
        e.stopPropagation();
        swipe.__esMoved = false;
      }
    },
    true
  );
})();